module.exports = __webpack_public_path__ + "img/FAAS_Helena_Convertible_Note_Press_Release_-_MZ_DRAFT_6.18.24_v4_clean_bahasaRevFN_-_revLgl.ec6149e0.png";